import React, { useState } from "react";

const initialContentSize = 100;

export const MessageContent = ({ content }) => {
  const [showMore, setShowMore] = useState(false);

  if (showMore) {
    return (
      <div style={{ width: "400px" }}>
        {content}
        <button title="Show less" style={{ color: "blue", border: "none", background: "none", cursor: "pointer" }} onClick={() => setShowMore(false)}>
          Less?
        </button>
      </div>
    );
  }
  return (
    <div style={{ width: "400px" }}>
      {content.substring(0, initialContentSize)}
      {content.length > initialContentSize && (
        <>
          <span>...</span>
          <button title="Show more" style={{ color: "blue", border: "none", background: "none", cursor: "pointer" }} onClick={() => setShowMore(true)}>
            More?
          </button>
        </>
      )}
    </div>
  );
};
